module.exports = __webpack_public_path__ + "img/icon_default_doctor_avatar.a3eb6b41.png";